export const getPercentage = (value) => {
	if (typeof value !== 'number' || Number.isNaN(value)) {
		return '-';
	}

	const result = value * 100;
	return `${result.toFixed(2)}%`;
};
